import {MenuItem} from '@material-ui/core';
import {SearchResult} from 'Core/ducks/search';
import React from 'react';
import {useDispatch} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import './SearchResult.sass';

type SearchResultProps = {
  itemProps: any;
  selected: boolean;
  result: SearchResult;
  onClose: () => any;
} & RouteComponentProps;

const SearchResultComponent = (props: SearchResultProps) => {
  const dispatch = useDispatch();

  return (
    <MenuItem
      onClick={() => {
        props.onClose();
        dispatch(props.result.selectRoute);
      }}
      key={props.itemProps.id}
      selected={props.selected}
      className="search-result"
    >
      <p style={{fontSize: '12px'}}>{props.result.label}</p>
    </MenuItem>
  );
};

export default withRouter(SearchResultComponent);
